import { useMutation } from '@apollo/client'
import { REGISTER_VOLUNTEER } from '@ec/apollo/src/mutations/auth'
import { LoginResponseType, RegisterType } from '@ec/types'
import { Button, DateInput, Input } from '@ec/ui'
import useErrorHandler from 'hooks/UseErrorHandler'
import { useEffect } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { login } from 'slices/auth'

const RegisterPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const errorHandler = useErrorHandler()

  const { register, handleSubmit, setValue, setError, clearErrors, formState: { errors } } = useForm<RegisterType>()

  const [registerMutation, { data: registerData, loading: isRegisterLoading, error: registerError }] = useMutation<{ registerVolunteer: LoginResponseType }>(REGISTER_VOLUNTEER)

  const onSubmit: SubmitHandler<RegisterType> = (form) => {
    registerMutation({
      variables: {
        input: {
          name: form.name,
          email: form.email,
          password: form.password,
          date_of_birth: form.date_of_birth,
        },
      },
    })
  }

  useEffect(() => {
    if (registerData) {
      dispatch(login(registerData.registerVolunteer))
      navigate('/')
    }
  }, [registerData])

  useEffect(() => {
    if (registerError) {
      errorHandler(registerError, setError)
    }
  }, [registerError])

  return (
    <div className="flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">Register your account</h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 sm:rounded-lg sm:px-10">

          <form className="space-y-6" onSubmit={(e) => {
            e.preventDefault()
            clearErrors()
            handleSubmit(onSubmit)(e)
          }}>

            <Input
              label="Name"
              required
              {...register('name')}
              error={errors.name?.message}
            />

            <DateInput label="Date of Birth" onChange={(date) => setValue('date_of_birth', date)} error={errors.date_of_birth?.message} />

            <Input
              label="Email"
              required
              {...register('email')}
              error={errors.email?.message}
              expanding
            />

            <Input
              label="Password"
              type="password"
              required
              {...register('password')}
              error={errors.password?.message}
            />

            <Button block isLoading={isRegisterLoading}>
              Register
            </Button>

            <div className="cf-turnstile" data-sitekey={process.env.REACT_APP_CLOUDFLARE_TURNSTILE_SITE_KEY}></div>
          </form>
        </div>
      </div>

    </div>
  )
}

export default RegisterPage